import clsx from 'clsx';

import { useConsultingCompanyMaxProjectsCountProgressBarQuery } from '@/graphql/generated';

import { LoaderFullscreen } from '@/components/layout/Loader';

export const ConsultingCompanyMaxProjectsCountProgressBar = ({
  companyId,
}: {
  companyId: string;
}) => {
  const companyMaxProjectsCountQuery =
    useConsultingCompanyMaxProjectsCountProgressBarQuery({
      variables: { companyId: companyId },
      fetchPolicy: 'network-only',
    });

  if (companyMaxProjectsCountQuery.loading) {
    return <LoaderFullscreen />;
  }

  const license = companyMaxProjectsCountQuery.data?.consultingCompany.license;
  const maxProjectsCount = license?.licensesCount || 0;
  const projectsCount =
    companyMaxProjectsCountQuery.data?.consultingCompany?.projectsCount || 0;
  const isUnlimited = maxProjectsCount === -1;
  const percentage = isUnlimited
    ? 100
    : maxProjectsCount
      ? Math.min((projectsCount / maxProjectsCount) * 100, 100)
      : 0;
  const okBgColor = !isUnlimited
    ? 'bg-green-500'
    : 'bg-gradient-to-r from-purple-500 to-purple-400';
  return (
    <div className="flex items-center gap-2 w-full">
      <div className="text-sm text-gray-500 shrink-0">
        {projectsCount}/{isUnlimited ? '∞' : maxProjectsCount}
      </div>

      <div className={clsx('w-full flex items-center justify-between gap-4')}>
        <div className="flex items-center bg-white rounded-md h-3 shrink-0 w-full">
          <div className="rounded-md bg-white w-full flex justify-between items-center relative">
            {/* Gray bar */}
            <div
              className={clsx(
                'absolute h-3 rounded-lg border-white border-2 flex justify-between items-center w-full bg-gray-100',
              )}
            ></div>

            {/* Colored bar */}
            <div
              className={clsx(
                'absolute h-3 rounded-lg border-white border-2 flex justify-between items-center',
                !maxProjectsCount ||
                  (!isUnlimited && projectsCount > maxProjectsCount)
                  ? 'bg-red-500'
                  : okBgColor,
              )}
              style={{ width: `${Math.max(percentage, 5)}%` }} // 5% is the minimum width to avoid weird rendering
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};
